/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const FlexRow = (props) => (
  <div className={classnames('cmp-flexrow', props.className)} style={props.style} onClick={props.onClick}>
    {props.children}
  </div>
);
FlexRow.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func,
};

export default FlexRow;
